import { useCallback, useRef } from 'react';
import { DomainSearchGateModule } from '../../../../module/domainSearchGate.module';
import { ViewMode } from '../../../../types';
export const useBusinessNamesBi = queryFromUrl => {
  const lastShownNamesRef = useRef([]);
  const firedNamesPromptRef = useRef(undefined);
  const onNamesShown = useCallback(shownNames => {
    const nameStrings = shownNames.map(n => n.name).filter(name => Boolean(name));
    lastShownNamesRef.current = nameStrings;
    if (firedNamesPromptRef.current === queryFromUrl) {
      return;
    }
    firedNamesPromptRef.current = queryFromUrl;
    DomainSearchGateModule.internals.bi.onBngBusinessNamesShown == null || DomainSearchGateModule.internals.bi.onBngBusinessNamesShown({
      searchTerm: queryFromUrl,
      searchOrigin: ViewMode.STOREFRONT_BNG,
      names: JSON.stringify(nameStrings),
      namesCount: nameStrings.length,
      trigger: 'search_submit'
    });
  }, [queryFromUrl]);
  const reportBackToNames = useCallback(() => {
    DomainSearchGateModule.internals.bi.onBngBusinessNamesShown == null || DomainSearchGateModule.internals.bi.onBngBusinessNamesShown({
      searchTerm: queryFromUrl,
      searchOrigin: ViewMode.STOREFRONT_BNG,
      names: JSON.stringify(lastShownNamesRef.current),
      namesCount: lastShownNamesRef.current.length,
      trigger: 'back_navigation'
    });
    DomainSearchGateModule.internals.bi.onBngGeneralAction == null || DomainSearchGateModule.internals.bi.onBngGeneralAction({
      action: 'back',
      button_name: 'back',
      domain: '',
      search_term: queryFromUrl
    });
  }, [queryFromUrl]);
  return {
    onNamesShown,
    reportBackToNames
  };
};
//# sourceMappingURL=useBusinessNamesBi.js.map